import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../../../shared/services/common/dialog/dialog.service';

declare var $: any;

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss']
})
export class DialogConfirmComponent implements OnInit {

	messageText: "";
	message: any = {};

	constructor(public dialogService: DialogService) { }

	ngOnInit() {
		//this function waits for a message from alert service, it gets   
		//triggered when we call this from any other component  
		this.dialogService.getConfirmMessage().subscribe(message => {
			this.message = message;
			if (message && message.text) {
				this.messageText = message.text;
				$('#confirm-modal').modal('show');
			}
		});
	}

	onYes() {
		this.message.yesFn();
		this.messageText = "";
		$('#confirm-modal').modal('hide');
	}

	onNo() {
		this.message.noFn();
		this.messageText = "";
		$('#confirm-modal').modal('hide');
	}

}
